export interface CountryType {
    code: string;
    label: string;
    phone: string;
}

export const countries: CountryType[] = [
    { code: 'AF', label: 'Afeganistão', phone: '93' },
    { code: 'ZA', label: 'África do Sul', phone: '27' },
    { code: 'AL', label: 'Albânia', phone: '355' },
    { code: 'DE', label: 'Alemanha', phone: '49' },
    { code: 'AD', label: 'Andorra', phone: '376' },
    { code: 'AO', label: 'Angola', phone: '244' },
    { code: 'AI', label: 'Anguila', phone: '1264' },
    { code: 'AQ', label: 'Antártida', phone: '672' },
    { code: 'AG', label: 'Antígua e Barbuda', phone: '1268' },
    { code: 'SA', label: 'Arábia Saudita', phone: '966' },
    { code: 'DZ', label: 'Argélia', phone: '213' },
    { code: 'AR', label: 'Argentina', phone: '54' },
    { code: 'AM', label: 'Armênia', phone: '374' },
    { code: 'AW', label: 'Aruba', phone: '297' },
    { code: 'AU', label: 'Austrália', phone: '61' },
    { code: 'AT', label: 'Áustria', phone: '43' },
    { code: 'AZ', label: 'Azerbaijão', phone: '994' },
    { code: 'BS', label: 'Bahamas', phone: '1242' },
    { code: 'BD', label: 'Bangladesh', phone: '880' },
    { code: 'BB', label: 'Barbados', phone: '1246' },
    { code: 'BH', label: 'Barém', phone: '973' },
    { code: 'BE', label: 'Bélgica', phone: '32' },
    { code: 'BZ', label: 'Belize', phone: '501' },
    { code: 'BJ', label: 'Benim', phone: '229' },
    { code: 'BM', label: 'Bermudas', phone: '1441' },
    { code: 'BY', label: 'Bielorrússia', phone: '375' },
    { code: 'BO', label: 'Bolívia', phone: '591' },
    { code: 'BA', label: 'Bósnia e Herzegovina', phone: '387' },
    { code: 'BW', label: 'Botsuana', phone: '267' },
    { code: 'BR', label: 'Brasil', phone: '55' },
    { code: 'BN', label: 'Brunei', phone: '673' },
    { code: 'BG', label: 'Bulgária', phone: '359' },
    { code: 'BF', label: 'Burquina Faso', phone: '226' },
    { code: 'BI', label: 'Burundi', phone: '257' },
    { code: 'BT', label: 'Butão', phone: '975' },
    { code: 'CV', label: 'Cabo Verde', phone: '238' },
    { code: 'CM', label: 'Camarões', phone: '237' },
    { code: 'KH', label: 'Camboja', phone: '855' },
    { code: 'CA', label: 'Canadá', phone: '1' },
    { code: 'QA', label: 'Catar', phone: '974' },
    { code: 'KZ', label: 'Cazaquistão', phone: '7' },
    { code: 'TD', label: 'Chade', phone: '235' },
    { code: 'CL', label: 'Chile', phone: '56' },
    { code: 'CN', label: 'China', phone: '86' },
    { code: 'CY', label: 'Chipre', phone: '357' },
    { code: 'CO', label: 'Colômbia', phone: '57' },
    { code: 'KM', label: 'Comores', phone: '269' },
    { code: 'CG', label: 'Congo-Brazzaville', phone: '242' },
    { code: 'CD', label: 'Congo-Kinshasa', phone: '243' },
    { code: 'KP', label: 'Coreia do Norte', phone: '850' },
    { code: 'KR', label: 'Coreia do Sul', phone: '82' },
    { code: 'CI', label: 'Costa do Marfim', phone: '225' },
    { code: 'CR', label: 'Costa Rica', phone: '506' },
    { code: 'HR', label: 'Croácia', phone: '385' },
    { code: 'CU', label: 'Cuba', phone: '53' },
    { code: 'CW', label: 'Curaçau', phone: '599' },
    { code: 'DK', label: 'Dinamarca', phone: '45' },
    { code: 'DJ', label: 'Djuti', phone: '253' },
    { code: 'DM', label: 'Dominica', phone: '1767' },
    { code: 'EG', label: 'Egito', phone: '20' },
    { code: 'SV', label: 'El Salvador', phone: '503' },
    { code: 'AE', label: 'Emirados Árabes Unidos', phone: '971' },
    { code: 'EC', label: 'Equador', phone: '593' },
    { code: 'ER', label: 'Eritreia', phone: '291' },
    { code: 'SK', label: 'Eslováquia', phone: '421' },
    { code: 'SI', label: 'Eslovênia', phone: '386' },
    { code: 'ES', label: 'Espanha', phone: '34' },
    { code: 'US', label: 'Estados Unidos', phone: '1' },
    { code: 'EE', label: 'Estônia', phone: '372' },
    { code: 'ET', label: 'Etiópia', phone: '251' },
    { code: 'FJ', label: 'Fiji', phone: '679' },
    { code: 'PH', label: 'Filipinas', phone: '63' },
    { code: 'FI', label: 'Finlândia', phone: '358' },
    { code: 'FR', label: 'França', phone: '33' },
    { code: 'GA', label: 'Gabão', phone: '241' },
    { code: 'GM', label: 'Gâmbia', phone: '220' },
    { code: 'GH', label: 'Gana', phone: '233' },
    { code: 'GE', label: 'Geórgia', phone: '995' },
    { code: 'GI', label: 'Gibraltar', phone: '350' },
    { code: 'GD', label: 'Granada', phone: '1473' },
    { code: 'GR', label: 'Grécia', phone: '30' },
    { code: 'GL', label: 'Groenlândia', phone: '299' },
    { code: 'GP', label: 'Guadalupe', phone: '590' },
    { code: 'GU', label: 'Guam', phone: '1671' },
    { code: 'GT', label: 'Guatemala', phone: '502' },
    { code: 'GG', label: 'Guernsey', phone: '44' },
    { code: 'GY', label: 'Guiana', phone: '592' },
    { code: 'GF', label: 'Guiana Francesa', phone: '594' },
    { code: 'GN', label: 'Guiné', phone: '224' },
    { code: 'GW', label: 'Guiné-Bissau', phone: '245' },
    { code: 'GQ', label: 'Guiné Equatorial', phone: '240' },
    { code: 'HT', label: 'Haiti', phone: '509' },
    { code: 'NL', label: 'Holanda', phone: '31' },
    { code: 'HN', label: 'Honduras', phone: '504' },
    { code: 'HK', label: 'Hong Kong', phone: '852' },
    { code: 'HU', label: 'Hungria', phone: '36' },
    { code: 'YE', label: 'Iêmen', phone: '967' },
    { code: 'IM', label: 'Ilha de Man', phone: '44' },
    { code: 'CX', label: 'Ilha Christmas', phone: '61' },
    { code: 'NF', label: 'Ilha Norfolk', phone: '672' },
    { code: 'AX', label: 'Ilhas Aland', phone: '358' },
    { code: 'KY', label: 'Ilhas Cayman', phone: '1345' },
    { code: 'CC', label: 'Ilhas Cocos', phone: '61' },
    { code: 'CK', label: 'Ilhas Cook', phone: '682' },
    { code: 'FO', label: 'Ilhas Faroé', phone: '298' },
    { code: 'FK', label: 'Ilhas Malvinas', phone: '500' },
    { code: 'MP', label: 'Ilhas Marianas do Norte', phone: '1670' },
    { code: 'MH', label: 'Ilhas Marshall', phone: '692' },
    { code: 'SB', label: 'Ilhas Salomão', phone: '677' },
    { code: 'TC', label: 'Ilhas Turks e Caicos', phone: '1649' },
    { code: 'VI', label: 'Ilhas Virgens Americanas', phone: '1340' },
    { code: 'VG', label: 'Ilhas Virgens Britânicas', phone: '1284' },
    { code: 'IN', label: 'Índia', phone: '91' },
    { code: 'ID', label: 'Indonésia', phone: '62' },
    { code: 'IR', label: 'Irã', phone: '98' },
    { code: 'IQ', label: 'Iraque', phone: '964' },
    { code: 'IE', label: 'Irlanda', phone: '353' },
    { code: 'IS', label: 'Islândia', phone: '354' },
    { code: 'IL', label: 'Israel', phone: '972' },
    { code: 'IT', label: 'Itália', phone: '39' },
    { code: 'JM', label: 'Jamaica', phone: '1876' },
    { code: 'JP', label: 'Japão', phone: '81' },
    { code: 'JE', label: 'Jersey', phone: '44' },
    { code: 'JO', label: 'Jordânia', phone: '962' },
    { code: 'KW', label: 'Kuwait', phone: '965' },
    { code: 'LA', label: 'Laos', phone: '856' },
    { code: 'LS', label: 'Lesoto', phone: '266' },
    { code: 'LV', label: 'Letônia', phone: '371' },
    { code: 'LB', label: 'Líbano', phone: '961' },
    { code: 'LR', label: 'Libéria', phone: '231' },
    { code: 'LY', label: 'Líbia', phone: '218' },
    { code: 'LI', label: 'Liechtenstein', phone: '423' },
    { code: 'LT', label: 'Lituânia', phone: '370' },
    { code: 'LU', label: 'Luxemburgo', phone: '352' },
    { code: 'MO', label: 'Macau', phone: '853' },
    { code: 'MK', label: 'Macedônia do Norte', phone: '389' },
    { code: 'MG', label: 'Madagascar', phone: '261' },
    { code: 'MY', label: 'Malásia', phone: '60' },
    { code: 'MW', label: 'Malaui', phone: '265' },
    { code: 'MV', label: 'Maldivas', phone: '960' },
    { code: 'ML', label: 'Mali', phone: '223' },
    { code: 'MT', label: 'Malta', phone: '356' },
    { code: 'MA', label: 'Marrocos', phone: '212' },
    { code: 'MQ', label: 'Martinica', phone: '596' },
    { code: 'MU', label: 'Maurício', phone: '230' },
    { code: 'MR', label: 'Mauritânia', phone: '222' },
    { code: 'YT', label: 'Mayotte', phone: '262' },
    { code: 'MX', label: 'México', phone: '52' },
    { code: 'MM', label: 'Mianmar', phone: '95' },
    { code: 'FM', label: 'Micronésia', phone: '691' },
    { code: 'MZ', label: 'Moçambique', phone: '258' },
    { code: 'MD', label: 'Moldávia', phone: '373' },
    { code: 'MC', label: 'Mônaco', phone: '377' },
    { code: 'MN', label: 'Mongólia', phone: '976' },
    { code: 'ME', label: 'Montenegro', phone: '382' },
    { code: 'MS', label: 'Montserrat', phone: '1664' },
    { code: 'NA', label: 'Namíbia', phone: '264' },
    { code: 'NR', label: 'Nauru', phone: '674' },
    { code: 'NP', label: 'Nepal', phone: '977' },
    { code: 'NI', label: 'Nicarágua', phone: '505' },
    { code: 'NE', label: 'Níger', phone: '227' },
    { code: 'NG', label: 'Nigéria', phone: '234' },
    { code: 'NU', label: 'Niue', phone: '683' },
    { code: 'NO', label: 'Noruega', phone: '47' },
    { code: 'NC', label: 'Nova Caledônia', phone: '687' },
    { code: 'NZ', label: 'Nova Zelândia', phone: '64' },
    { code: 'OM', label: 'Omã', phone: '968' },
    { code: 'PW', label: 'Palau', phone: '680' },
    { code: 'PS', label: 'Palestina', phone: '970' },
    { code: 'PA', label: 'Panamá', phone: '507' },
    { code: 'PG', label: 'Papua-Nova Guiné', phone: '675' },
    { code: 'PK', label: 'Paquistão', phone: '92' },
    { code: 'PY', label: 'Paraguai', phone: '595' },
    { code: 'PE', label: 'Peru', phone: '51' },
    { code: 'PF', label: 'Polinésia Francesa', phone: '689' },
    { code: 'PL', label: 'Polônia', phone: '48' },
    { code: 'PR', label: 'Porto Rico', phone: '1' },
    { code: 'PT', label: 'Portugal', phone: '351' },
    { code: 'KE', label: 'Quênia', phone: '254' },
    { code: 'KG', label: 'Quirguistão', phone: '996' },
    { code: 'GB', label: 'Reino Unido', phone: '44' },
    { code: 'CF', label: 'República Centro-Africana', phone: '236' },
    { code: 'CZ', label: 'República Tcheca', phone: '420' },
    { code: 'DO', label: 'República Dominicana', phone: '1809' },
    { code: 'RE', label: 'Reunião', phone: '262' },
    { code: 'RO', label: 'Romênia', phone: '40' },
    { code: 'RW', label: 'Ruanda', phone: '250' },
    { code: 'RU', label: 'Rússia', phone: '7' },
    { code: 'WS', label: 'Samoa', phone: '685' },
    { code: 'SM', label: 'San Marino', phone: '378' },
    { code: 'SH', label: 'Santa Helena', phone: '290' },
    { code: 'LC', label: 'Santa Lúcia', phone: '1758' },
    { code: 'BL', label: 'São Bartolomeu', phone: '590' },
    { code: 'KN', label: 'São Cristóvão e Névis', phone: '1869' },
    { code: 'MF', label: 'São Martinho', phone: '590' },
    { code: 'PM', label: 'São Pedro e Miquelon', phone: '508' },
    { code: 'ST', label: 'São Tomé e Príncipe', phone: '239' },
    { code: 'VC', label: 'São Vicente e Granadinas', phone: '1784' },
    { code: 'SN', label: 'Senegal', phone: '221' },
    { code: 'SL', label: 'Serra Leoa', phone: '232' },
    { code: 'RS', label: 'Sérvia', phone: '381' },
    { code: 'SC', label: 'Seychelles', phone: '248' },
    { code: 'SG', label: 'Singapura', phone: '65' },
    { code: 'SX', label: 'Sint Maarten', phone: '1721' },
    { code: 'SY', label: 'Síria', phone: '963' },
    { code: 'SO', label: 'Somália', phone: '252' },
    { code: 'LK', label: 'Sri Lanka', phone: '94' },
    { code: 'SZ', label: 'Suazilândia', phone: '268' },
    { code: 'SD', label: 'Sudão', phone: '249' },
    { code: 'SS', label: 'Sudão do Sul', phone: '211' },
    { code: 'SE', label: 'Suécia', phone: '46' },
    { code: 'CH', label: 'Suíça', phone: '41' },
    { code: 'SR', label: 'Suriname', phone: '597' },
    { code: 'TH', label: 'Tailândia', phone: '66' },
    { code: 'TW', label: 'Taiwan', phone: '886' },
    { code: 'TJ', label: 'Tajiquistão', phone: '992' },
    { code: 'TZ', label: 'Tanzânia', phone: '255' },
    { code: 'TL', label: 'Timor-Leste', phone: '670' },
    { code: 'TG', label: 'Togo', phone: '228' },
    { code: 'TK', label: 'Tokelau', phone: '690' },
    { code: 'TO', label: 'Tonga', phone: '676' },
    { code: 'TT', label: 'Trinidad e Tobago', phone: '1868' },
    { code: 'TN', label: 'Tunísia', phone: '216' },
    { code: 'TM', label: 'Turcomenistão', phone: '993' },
    { code: 'TR', label: 'Turquia', phone: '90' },
    { code: 'TV', label: 'Tuvalu', phone: '688' },
    { code: 'UA', label: 'Ucrânia', phone: '380' },
    { code: 'UG', label: 'Uganda', phone: '256' },
    { code: 'UY', label: 'Uruguai', phone: '598' },
    { code: 'UZ', label: 'Uzbequistão', phone: '998' },
    { code: 'VU', label: 'Vanuatu', phone: '678' },
    { code: 'VA', label: 'Vaticano', phone: '379' },
    { code: 'VE', label: 'Venezuela', phone: '58' },
    { code: 'VN', label: 'Vietnã', phone: '84' },
    { code: 'WF', label: 'Wallis e Futuna', phone: '681' },
    { code: 'ZM', label: 'Zâmbia', phone: '260' },
    { code: 'ZW', label: 'Zimbábue', phone: '263' },
].sort((a, b) => a.label.localeCompare(b.label));

export const getCountryByNumber = (number: string | null | undefined): CountryType | null => {
    if (!number) return null;
    const sorted = [...countries].sort((a, b) => b.phone.length - a.phone.length);
    const numStr = number.replace(/\D/g, '');
    return sorted.find(c => numStr.startsWith(c.phone)) || null;
};
